import { useState, useEffect, useRef } from 'react'
import { NoRecords, PageLoader } from '../../lib/loader'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import moment from 'moment';
import { useGetBlockedUsers, useUpdateUserBlock } from './UserDetailapi';
import { Search, Copy, Check } from 'lucide-react';
import { useDebounce } from '../../hooks/debounce';
import { useParams } from 'react-router-dom';
import { queryClient } from "../../config";
import { copyToClipboard } from '../../lib/copytoClipboard';
import { useModalContext } from '../../contexts/ModalContext';
import { useToast } from '../../hooks/usetoast';
import { useCheckAdminAccess } from '../WhiteIp/api/whiteipapi';
import { logout } from '../../hooks/logout';
import PermissionDenied from '../common/permissionDenied';
import { useBreadcrumbPagination } from '../../hooks/useBreadcrumbPagination';
import BreadcrumbPagination from '../../utils/BreadcrumbPagination';


function BlockedUsers() {

    const [tempPage, setTempPage] = useState(0);
    const [tempRows, setTempRows] = useState(25);
    const [search, setSearch] = useState("");
    const searchText = useDebounce(search);
    const { id } = useParams();
    const { theme } = useModalContext()
    const toast = useToast();
    const [userEmail, setUserEmail] = useState(false);

    const { data: getBlockedUsers, isLoading } = useGetBlockedUsers({
        id,
        page: searchText ? 0 : tempPage,
        size: tempRows,
        searchText,
        sortField: "createdAt",
        sortOrder: "desc"
    })

    const totalRecords = getBlockedUsers?.data?.totalRecords || 0;

    const {
        page,
        rowsPerPage,
        totalPages,
        handleChangePage,
        handleChangeRowsPerPage
    } = useBreadcrumbPagination(totalRecords, tempRows);

    useEffect(() => {
        setTempPage(page);
    }, [page]);

    useEffect(() => {
        setTempRows(rowsPerPage);
    }, [rowsPerPage]);

    const inputRef = useRef(null);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
            const length = inputRef.current.value.length;
            inputRef.current.setSelectionRange(length, length);
        }
    });

    useEffect(() => {
        setTempPage(0);
        if (handleChangePage) {
            handleChangePage(null, 0);
        }
    }, [searchText]);


    const updateBlockstatus = useUpdateUserBlock()


    const userStatus = async (item, updateField) => {
        let obj = {
            id: item._id,
            isUpdateStatus: updateField,
        };
        const updateStatus = await updateBlockstatus.mutateAsync({ ...obj });
        if (!updateStatus) {
            return toast.error(updateStatus?.data?.message)
        }
        else {
            toast.success(updateStatus?.data?.message)
            queryClient.refetchQueries('blocked-users')
        }
    };

    const copyUserEmailAddress = async data => {
        setUserEmail(data._id)
        await copyToClipboard(data?.email)
        toast.success("Email Address copied")
        setTimeout(() => {
            setUserEmail()
        }, 800)
    }


    const checkAdminMutation = useCheckAdminAccess();
    const [access, setAccess] = useState(true);

    useEffect(() => {
        checkAdminAccess();
    }, []);

    const checkAdminAccess = async () => {
        try {
            const obj = { page: "User Management" };
            const checkAdminRes = await checkAdminMutation.mutateAsync(obj);
            if (!checkAdminRes?.data?.status) {
                setAccess(false);
                logout();
            } else {
                setAccess(true);
            }
        } catch (error) {
            setAccess(false);
        }
    };

    const renderUserHistoryTable = () => (
        getBlockedUsers?.data?.data?.length > 0 ? (
            <>
                <div style={{ minHeight: "60vh" }}>
                    <div className='table-responsive'>
                        <Table sx={{ minWidth: 650 }} aria-label="user history table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">S.NO</TableCell>
                                    <TableCell align="center">User Name</TableCell>
                                    <TableCell align="center">Email</TableCell>
                                    <TableCell align="center">Unblock user Account</TableCell>
                                    <TableCell align="center">Date and Time </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {getBlockedUsers?.data?.data?.map((row, i) => (
                                    <TableRow key={row._id || i}>
                                        <TableCell align="center">{page * rowsPerPage + (i + 1)}</TableCell>
                                        <TableCell align="center">{row?.userName || "-"}</TableCell>
                                        <TableCell align="center">
                                            {row?.email || "-"}
                                            {row?.email && userEmail !== row._id && (
                                                <Copy
                                                    onClick={() => copyUserEmailAddress(row)}
                                                    size={20}
                                                    className='ml-5'
                                                    style={{
                                                        cursor: "pointer",
                                                        marginLeft: "5px",
                                                        color: theme ? "white" : "black"
                                                    }}
                                                />
                                            )}
                                            {row?.email && userEmail === row._id && (
                                                <Check
                                                    size={20}
                                                    style={{
                                                        marginLeft: "5px",
                                                        color: theme ? "white" : "black"
                                                    }}
                                                />
                                            )}
                                        </TableCell>
                                        <TableCell>
                                            <div className="form-check form-switch" style={{ justifyContent: "center" }}>
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    role="switch"
                                                    id={`flexSwitchCheckDefault-${row._id}`}
                                                    checked={row?.isBlocked}
                                                    onChange={() => userStatus(row, !row?.isBlocked)}
                                                />
                                            </div>
                                        </TableCell>


                                        <TableCell align="center">
                                            {moment(row?.updatedAt).format("DD-MM-YYYY | hh:mm A")}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </div>
                </div>
                <BreadcrumbPagination
                    page={page}
                    rowsPerPage={rowsPerPage}
                    totalPages={totalPages}
                    totalRecords={totalRecords}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                />

            </>
        ) : (
            <NoRecords />
        )
    );


    return (
        <>
            {isLoading ? (
                <PageLoader />
            ) : access ? (
                <section>
                    <h4>Temporary Account Blocked Users</h4>
                    <div className="ad_pg_bx bg-white p-3">
                        <div className='d-flex justify-content-between align-items-center mb-2'>
                            <div className='col-md-4'>
                                <div className="input-group">
                                    <span className="input-group-icon">
                                        <Search size={20} color='#aaa9a9' />
                                    </span>
                                    <input
                                        type="text"
                                        ref={inputRef}
                                        onChange={(e) => setSearch(e.target.value)}
                                        value={search}
                                        className="form-control"
                                        placeholder="Search by name , email"
                                    />
                                </div>
                            </div>
                        </div>
                        {renderUserHistoryTable()}
                    </div>
                </section>
            ) : (
                <PermissionDenied />
            )}


        </>
    )
}

export default BlockedUsers